import { render } from "./CitiesSearch.vue?vue&type=template&id=bb48b96e&ts=true"
import script from "./CitiesSearch.vue?vue&type=script&lang=ts"
export * from "./CitiesSearch.vue?vue&type=script&lang=ts"

import "./CitiesSearch.vue?vue&type=style&index=0&id=bb48b96e&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__